import classes from "../classes";
import Image from "./image";
import pure from "./higher-order/pure";
import React from "react";

var shapes = [
  "", // circles
  "avatar--is-diamond",
  "avatar--is-checkered",
  "avatar--is-striped",
  "avatar--is-diagonal"
];

var colors = [
  "", // blue
  "avatar--is-red",
  "avatar--is-forest-green",
  "avatar--is-khaki",
  "avatar--is-fuchsia",
  "avatar--is-purple",
  "avatar--is-black",
  "avatar--is-brown",
  "avatar--is-maroon",
  "avatar--is-green",
  "avatar--is-pink",
  "avatar--is-yellow",
];

var variations = [];
for (var s = 0; s < shapes.length; s++) {
  for (var c = 0; c < colors.length; c++) {
    variations.push(" " + shapes[s] + " " + colors[c]);
  }
}

export default pure(function Avatar({ medium, small, tiny, user }) {
  if (!user) {
    console.warn("user doesn't exist");
    return null;
  }
  var variation = variations[user.get("id") % variations.length];

  var url = "https://s3.amazonaws.com/" + window.env.avatarBucket + "/resized/300/" + user.get("id") + ".jpg";
  var timestamp = user.get("timestamp");
  if (timestamp) {
    url += "?t=" + timestamp;
  }
  return (
    <Image
      className={classes({
        "avatar": true,
        "avatar--is-medium": medium,
        "avatar--is-small": small,
        "avatar--is-tiny": tiny,
      })}
      src={url}>
      <span
        aria-label={getInitials(user)}
        className={classes({
          "avatar": true,
          "avatar--is-medium": medium,
          "avatar--is-small": small,
          "avatar--is-tiny": tiny,
        }) + variation} />
    </Image>
  );
});

function getInitials(user) {
  var first = user.get("first_name");
  var last = user.get("last_name");
  var username = user.get("username");

  if (first) {
    return first[0] + last[0];
  } else {
    return username.substr(0, 2);
  }
}
